import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SvgArrowNarrowDownFill } from '../SvgIcons';



const TypographyRoot = styled(Typography)(
  ({ theme }) => `
    white-space: nowrap;
    i {
      display: flex;
      overflow: hidden;
      position: relative;
      svg:nth-of-type(1) {
        transition: all 0.5s;
      }
      svg:nth-of-type(2) {
        position: absolute;
        left: 0px;
        top: -25px;
        transform: translate(0, 0);
        opacity: 0;
        visibility: hidden;
        transition: all 0.5s;
      }
    }
    &:hover{
      i{
        svg:nth-of-type(1) {
          transform: translate(0px, 20px);
        }
        svg:nth-of-type(2) {
          opacity: 1;
          visibility: visible;
          transform: translate(0px, 25px);
        }
      }
    }
  `
);

export default function TypographyCheck({ primary, children, iconColor, textColor, maxWidth= 348, onClick, ...other }) {
  return (
    <TypographyRoot
      onClick={onClick}
      display={'inline-flex'}
      alignItems={'center'}
      gap={1}
      maxWidth={maxWidth}
      fontSize={18}
      fontWeight={700}
      color={textColor}
      textAlign={'left'}
      p={1}
      { ...other }
    >
      { primary || children }
      <Box component={'i'}>
        <SvgArrowNarrowDownFill color={iconColor} />
        <SvgArrowNarrowDownFill color={iconColor} />
      </Box>
    </TypographyRoot>
  )
}
